import { AppDispatch } from "redux/store";
import { CallLambda } from "./CallLambda";
import Session from "redux/classes/Session";
import { notification } from "antd";

/**
 * Download an input file the user has selected on the Run page so they can
 * inspect its shape before running. We request a presigned URL from
 * objectLoader for `input/<s3_subfolder>/<filename>`, then trigger the
 * browser to download it via a temporary anchor — same pattern as
 * SaveObject for run outputs.
 */
export function LoadInputAction(session: Session, modelAlias: string, s3Path: string, displayName: string) {
    return async (dispatch: AppDispatch) => {
        const payload = JSON.stringify({
            "model": modelAlias,
            "path": s3Path,
        });

        const response: {status: number, data: any} = await dispatch(CallLambda(session, "objectLoader", payload));

        if (response.status !== 200 || !response.data?.url) {
            notification.error({
                message: "Download failed",
                description: `Could not fetch ${displayName} from S3.`,
                placement: "top",
                duration: 5,
            });
            return;
        }

        const a = document.createElement("a");
        a.setAttribute("download", displayName);
        a.setAttribute("href", atob(response.data.url));
        a.click();
    };
}
